import { useAppSettings } from '../hooks/useAppSettings';
import DOMPurify from 'isomorphic-dompurify';
import '../sass/components/banner.scss';
export default function Banner(props) {
  const settings = useAppSettings();

  return (
      <div className="banner" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(settings['banner'], { FORCE_BODY: true, SAFE_FOR_TEMPLATES: false, ALLOWED_TAGS: ['div', 'table', 'td', 'tr', 'br', 'p', 'span', 'Link', 'h4', 'ul', 'li', 'a', 'img', 'script'], ALLOWED_ATTR: ['class', 'style', 'href', 'src', 'width', 'height', 'alt', 'async', 'data-elfsight-app-lazy', ' data-use-service-core'] }) }}/>
  );
}